import { ActionsUnion } from "../../type/actionsUnion"
import createAction from "../../type/createAction"
import { StoreState } from "../StoreState"

export type MerchantCreateState = Readonly<{
    createMerchantStatus: { [crn: string]: IMerchantCreateStatusResponse }
}>

export interface IMerchantCreateStatusResponse {
    isAlreadyCreated: boolean
    isOwnerConfirmed: boolean
    ownerEmail: string
    isDeleted: boolean
    isCoreServicesStopped: boolean
    isAllServicesStopped: boolean
    isMarkedForDeletion: boolean
}

const initialState: MerchantCreateState = {
    createMerchantStatus: {},
}

export const merchantCreateReducerActions = {
    setCreateMerchantStatus: (crn: string, status: IMerchantCreateStatusResponse) =>
        createAction("APP/SET_CREATE_MERCHANT_STATUS", { crn, status }),
}

export type MerchantCreateActions = ActionsUnion<typeof merchantCreateReducerActions>

export const merchantCreateReducer = (state: MerchantCreateState = initialState, action: MerchantCreateActions) => {
    switch (action.type) {
        case "APP/SET_CREATE_MERCHANT_STATUS": {
            return {
                ...state,
                createMerchantStatus: {
                    ...state.createMerchantStatus,
                    [action.crn]: action.status,
                },
            }
        }
        default: {
            return state
        }
    }
    return state
}

export const merchantCreateSelectors = {
    merchantCreateStatus: (state: StoreState, crn: string) => state.merchantCreate.createMerchantStatus[crn],
}
